import * as React from 'react';

import { Link } from 'react-router-dom';

import cx from 'classnames';

interface IGroupButton {
  text: string;

  icon: any;

  textColorClass?: string;

  onClick?: () => void;

  href?: string;

  disabled?: boolean;

  fontSize?: string;
}

interface GroupButtonProps {
  buttons: Array<IGroupButton>;
}

const GroupButton: React.FC<GroupButtonProps> = (props) => {
  const btnClass = (textColorClass: string, disabled: boolean) => {
    return cx('flex items-center gap-0 md:gap-[4px] cursor-pointer', {
      [textColorClass]: true,

      'opacity-50 pointer-events-none': disabled,
    });
  };

  return (
    <div className="flex justify-evenly md:flex-wrap">
      <div className="bg-[#D9D9D9] h-[48px] bg-opacity-20 font-medium rounded-[4px] py-[5px] flex md:flex-wrap border-opacity-10 gap-[0px] border border-[#000000]">
        {props.buttons.map((btn, index) => {
          const Comp = btn.href ? Link : 'span';

          return (
            <React.Fragment key={index}>
              <Comp
                to={btn.href || '#'}
                onClick={btn.onClick}
                className={btnClass(
                  `text-[#044E97] md:text-[12px] text-[10px] xl:text-[16px] 2xl:text-[18px] ${btn.fontSize} whitespace-nowrap px-3 py-2`,

                  btn.disabled || false,
                )}
              >
                {btn.text} {btn.icon}
              </Comp>

              {index !== props.buttons.length - 1 && (
                <span className="border-l border-[#000000] border-opacity-20 xl:ml-2 xl:mr-2 xl:mr-19 2xl:mr-0" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export { GroupButton };
